(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carey-portfolio"] && !Shopify.designMode) return;
  try {
    

(() => {
  const root = document.getElementById('carey-epk');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const shopAnchors = new Set(['#games','#monthly-collections','#wildcard','#vibelink','#music']);
  document.querySelectorAll('a[href]').forEach(link => {
    const href=link.getAttribute('href');
    if(shopAnchors.has(href))link.href='https://vibesandvirtues.com/'+href;
    if(location.hostname==='careyfountain.vibesandvirtues.com' && href==='/')link.href='https://vibesandvirtues.com/';
  });
  const $ = s => root.querySelector(s);
  const $$ = s => [...root.querySelectorAll(s)];
  const i18n=JSON.parse($('#cf-translations').textContent);
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const storeHeader=document.getElementById('new-header-wildcard_header');
  if(storeHeader){const updateOffset=()=>{root.style.setProperty('--store-header-offset',storeHeader.getBoundingClientRect().height+'px');};updateOffset();new ResizeObserver(updateOffset).observe(storeHeader);}
  const scrollToContact = () => $('#cf-contact').scrollIntoView({behavior:reduced ? 'instant':'smooth'});
  $$('.filter').forEach(button => button.addEventListener('click', () => {
    $$('.filter').forEach(b => {b.classList.toggle('active', b === button);b.setAttribute('aria-pressed',String(b === button));});
    let count = 0;
    $$('.project').forEach(project => {const show = button.dataset.filter === 'All' || project.dataset.category === button.dataset.filter;project.hidden = !show;if(show) count++;});
    $('#work-status').textContent = i18n.t306.replace('__COUNT__',count);
  }));
  const caseDialog = $('#case-dialog');
  const mediaDialog = $('#media-dialog');
  let dialogTrigger;
  function openDialog(dialog, trigger) {dialogTrigger = trigger;dialog.showModal();document.documentElement.style.overflow = 'hidden';dialog.scrollTop = 0;}
  function closeDialog(dialog) {dialog.close();}
  $$('dialog').filter(dialog => dialog.querySelector('[data-close]')).forEach(dialog => {
    dialog.querySelector('[data-close]').addEventListener('click', () => closeDialog(dialog));
    dialog.addEventListener('click', e => {if (e.target === dialog) {const box = dialog.getBoundingClientRect();if(e.clientX < box.left || e.clientX > box.right || e.clientY < box.top || e.clientY > box.bottom) closeDialog(dialog);}});
    dialog.addEventListener('close', () => {document.documentElement.style.overflow = '';if(dialog === mediaDialog) $('#media-content').replaceChildren();dialogTrigger?.focus();});
  });
  $$('[data-project]').forEach(button => button.addEventListener('click', () => {
    if(button.dataset.project==='paintings'){openArtworks(button);return;}
    $('#case-content').replaceChildren($('#project-'+button.dataset.project).content.cloneNode(true));
    $('#case-content').querySelector('[data-case-inquiry]').addEventListener('click', e => {e.preventDefault();const title=e.currentTarget.dataset.caseInquiry;closeDialog(caseDialog);$('#inquiry-form textarea').value=i18n.t307.replace('__TITLE__',title);setInterest(e.currentTarget.dataset.caseInterest || (title === 'Ways of seeing' ? 'Art & commissions':'Experiences & programming'));scrollToContact();});
    openDialog(caseDialog,button);
  }));
  $$('[data-film]').forEach(button => button.addEventListener('click', () => {
    $('#media-title').textContent=i18n.t308;
    const video=document.createElement('video');video.controls=true;video.playsInline=true;video.preload='metadata';video.src=root.dataset.filmUrl;video.poster=root.dataset.filmPoster;video.setAttribute('aria-label',i18n.t309);
    $('#media-content').replaceChildren(video);
    $('#media-note').textContent=i18n.t310;
    openDialog(mediaDialog,button);
  }));
  $$('[data-youtube]').forEach(button => button.addEventListener('click', () => {
    $('#media-title').textContent=button.dataset.videoTitle;
    const art=button.querySelector('img').cloneNode();art.loading='eager';art.className='music-dialog-art';
    const watch=document.createElement('a');watch.href='https://www.youtube.com/watch?v='+encodeURIComponent(button.dataset.youtube);watch.target='_blank';watch.rel='noopener';watch.textContent=i18n.t311;watch.className='button light';
    const actions=document.createElement('div');actions.className='music-dialog-actions';actions.append(watch);
    button.closest('.record').querySelectorAll('.link-row a').forEach(a=>actions.append(a.cloneNode(true)));
    $('#media-content').replaceChildren(art,actions);
    $('#media-note').textContent=button.closest('.record').querySelector('p').textContent;
    openDialog(mediaDialog,button);
  }));
  const tabs=$$('[data-stage]');
  function showStage(button,focus=false) {tabs.forEach(b => {const selected=b === button;b.setAttribute('aria-selected',String(selected));b.tabIndex=selected ? 0 : -1;$('#journey-'+b.dataset.stage).hidden=!selected;});if(focus)button.focus();}
  tabs.forEach((button,index) => {button.addEventListener('click',()=>showStage(button));button.addEventListener('keydown',e=>{let n;if(e.key==='ArrowRight')n=(index+1)%tabs.length;if(e.key==='ArrowLeft')n=(index+tabs.length-1)%tabs.length;if(e.key==='Home')n=0;if(e.key==='End')n=tabs.length-1;if(n!==undefined){e.preventDefault();showStage(tabs[n],true);}});});
  $('#social-signal').addEventListener('click',e=>{const on=e.currentTarget.getAttribute('aria-checked')!=='true';e.currentTarget.setAttribute('aria-checked',String(on));$('#signal-label').textContent=on?i18n.t312:i18n.t313;});
  function setInterest(value) {$('#inquiry-form select[name=interest]').value=value;$$('.opportunities button').forEach(b=>b.classList.toggle('chosen',b.dataset.interest===value));}
  $$('[data-interest]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();setInterest(b.dataset.interest);if(b.hasAttribute('data-insight-inquiry')){const message=$('#inquiry-form textarea');if(!message.value.trim())message.value=$('#inquiry-form').dataset.insightFocus;}if(b.tagName==='A')scrollToContact();}));
  $('#inquiry-form select[name=interest]').addEventListener('change',e=>setInterest(e.target.value));
  const inquiryForm=$('#inquiry-form');
  let inquiryAttempt=null, inquirySending=false;
  inquiryForm.addEventListener('submit',async e=>{
    e.preventDefault();
    if(inquirySending || !inquiryForm.reportValidity())return;
    const fields=Object.fromEntries(new FormData(inquiryForm));
    const fingerprint=JSON.stringify(fields);
    if(!inquiryAttempt || inquiryAttempt.fingerprint!==fingerprint)inquiryAttempt={fingerprint,requestId:crypto.randomUUID()};
    const button=inquiryForm.querySelector('button[type="submit"]');
    const status=$('#inquiry-status');
    const label=button.textContent;
    inquirySending=true;button.disabled=true;button.textContent=inquiryForm.dataset.loading;
    inquiryForm.setAttribute('aria-busy','true');status.textContent='';status.dataset.state='';
    const controller=new AbortController();
    const timeout=setTimeout(()=>controller.abort(),30000);
    try{
      const response=await fetch(inquiryForm.dataset.endpoint,{
        method:'POST',headers:{'Content-Type':'application/json',Authorization:'Bearer '+inquiryForm.dataset.publicKey,apikey:inquiryForm.dataset.publicKey},
        body:JSON.stringify({...fields,requestId:inquiryAttempt.requestId}),signal:controller.signal
      });
      const result=await response.json();
      if(!response.ok || !result.ok){
        status.textContent=response.status===429?inquiryForm.dataset.rate:inquiryForm.dataset.error;
        status.dataset.state='error';
        if(response.status===409)inquiryAttempt=null;
      }else{
        status.textContent=inquiryForm.dataset.success;status.dataset.state='success';
        inquiryForm.reset();setInterest('');inquiryAttempt=null;
      }
    }catch{
      status.textContent=inquiryForm.dataset.error;status.dataset.state='error';
    }finally{
      clearTimeout(timeout);inquirySending=false;button.disabled=false;button.textContent=label;
      inquiryForm.removeAttribute('aria-busy');status.focus({preventScroll:true});
      status.scrollIntoView({behavior:reduced?'instant':'smooth',block:'nearest'});
    }
  });
  const feeds = new Map();
  const safeUrl = value => {try {const u=new URL(value,'https://vibesandvirtues.com');return u.protocol==='https:'?u.href:'';} catch{return '';}};
  const largerImage = value => {const url=safeUrl(value);if(!url)return '';const u=new URL(url);u.pathname=u.pathname.replace(/_(?:350x_crop_center|large)(?=\.)/,'');if(u.hostname.includes('shopify.com')||u.hostname==='vibesandvirtues.com')u.searchParams.set('width','1600');return u.href;};
  const snapshot = kind => JSON.parse($('#cf-'+kind+'-feed').textContent);
  function sourceItems(html,kind) {
    const doc=new DOMParser().parseFromString(html,'text/html');
    if(kind==='music') {
      const source=doc.getElementById('vv-music-catalog');
      if(source) return JSON.parse(source.textContent).map(r=>({title:r.title,description:r.detail||'',year:Number(r.digitalReleaseDate?.slice(0,4)||r.year),releaseDate:r.digitalReleaseDate||'',id:r.id,image:safeUrl(r.image),thumbnail:safeUrl(r.image),url:safeUrl(r.url)})).filter(r=>r.title&&r.image&&r.url).sort((a,b)=>b.year-a.year||b.releaseDate.localeCompare(a.releaseDate)||b.id-a.id);
    }
    return [...doc.querySelectorAll('.visual-item')].flatMap(card=>{
      const img=card.querySelector('img'),heading=card.querySelector('h3,h2'),a=card.matches('a')?card:card.querySelector('a[href]');
      if(!img||!heading)return [];
      const url=safeUrl(a?.getAttribute('href')||'/pages/about-carey-'+kind),thumbnail=safeUrl(img.getAttribute('src')||img.getAttribute('data-src'));
      const paragraphs=[...card.querySelectorAll('p')].map(x=>x.textContent.trim());
      return [{title:heading.textContent.trim(),description:paragraphs[0]||'',year:paragraphs.at(-1)||'',image:largerImage(/\.(?:jpe?g|png|webp)(?:\?|$)/i.test(url)?url:thumbnail),thumbnail,url}];
    }).filter(item=>item.image&&item.title);
  }
  function fetchFeed(kind) {
    if(!feeds.has(kind))feeds.set(kind,fetch(root.dataset[kind+'Url'],{cache:'no-cache',signal:AbortSignal.timeout(15000)}).then(r=>{if(!r.ok)throw new Error('Portfolio unavailable');return r.text();}).then(html=>{const items=sourceItems(html,kind);if(!items.length)throw new Error('No portfolio entries');if(kind==='music')$('.records').dataset.feedState='live';return items;}).catch(()=>{if(kind==='music')$('.records').dataset.feedState='fallback';return snapshot(kind);}));
    return feeds.get(kind);
  }
  function makeImage(item) {
    const im=document.createElement('img');im.src=largerImage(item.image);im.alt=item.title;im.decoding='async';im.addEventListener('error',()=>{if(im.dataset.fallback)return;im.dataset.fallback='true';im.src=item.thumbnail;});return im;
  }
  let musicItems=[], musicLimit=3;
  const musicMore=document.createElement('div');musicMore.className='music-more';
  const musicCount=document.createElement('p');musicCount.setAttribute('aria-live','polite');
  const musicButton=document.createElement('button');musicButton.type='button';musicButton.className='button quiet';musicButton.textContent='Show more music';
  musicMore.append(musicCount,musicButton);$('.records').after(musicMore);
  function renderMusic(items) {
    musicItems=items;
    const grid=$('.records');const fragment=document.createDocumentFragment();
    items.slice(0,musicLimit).forEach((item,index)=>{
      const article=document.createElement('article');article.className='record';
      const cover=document.createElement('a');cover.className='record-art';cover.href=item.url;cover.target='_blank';cover.rel='noopener';cover.setAttribute('aria-label','Listen to '+item.title);
      const image=makeImage(item);image.loading='lazy';cover.append(image);const label=document.createElement('span');label.textContent='Listen & watch';cover.append(label);
      const line=document.createElement('div');line.className='record-line';const date=document.createElement('span');date.className='tiny';date.textContent=String(index+1).padStart(2,'0')+' / '+item.year;const title=document.createElement('h3');title.textContent=item.title;line.append(date,title);
      const text=document.createElement('p');text.textContent=item.description===item.year?'':item.description;
      const link=document.createElement('a');link.className='text-link';link.href=item.url;link.target='_blank';link.rel='noopener';link.textContent='Explore this release';article.append(cover,line,text,link);fragment.append(article);
    });grid.replaceChildren(fragment);grid.dataset.source='music-portfolio';grid.dataset.total=items.length;
    musicCount.textContent='Showing '+Math.min(musicLimit,items.length)+' of '+items.length+' releases.';
    musicButton.hidden=musicLimit>=items.length;
  }
  musicButton.addEventListener('click',()=>{const firstNew=musicLimit;musicLimit+=6;renderMusic(musicItems);$('.records').children[firstNew]?.querySelector('a')?.focus({preventScroll:true});});
  musicCount.textContent='Loading the latest releases…';
  fetchFeed('music').then(renderMusic);
  let artworkSession=0;
  async function openArtworks(trigger) {
    const session=++artworkSession;let items=snapshot('visual');let index=0;
    const arrange=rows=>{const copy=[...rows],i=copy.findIndex(x=>/self portrait\s*#?\s*1/i.test(x.title));if(i>0)copy.unshift(copy.splice(i,1)[0]);return copy;};items=arrange(items);
    $('#case-content').innerHTML='<div class="art-intro"><p class="eyebrow">The visual portfolio</p><h2 id="case-title">Ways of seeing</h2><p>Explore the complete collection of artworks, installations, and visual projects.</p></div><div class="art-carousel" aria-roledescription="carousel" aria-label="Carey Fountain visual portfolio"><div class="art-stage"></div><div class="art-controls"><button type="button" class="button quiet" data-art-prev aria-label="Previous artwork">Previous</button><p class="art-position" aria-live="polite"></p><button type="button" class="button quiet" data-art-next aria-label="Next artwork">Next</button></div><div class="art-description"><h3></h3><p></p><a class="text-link" target="_blank" rel="noopener">View original work</a></div><label class="art-jump">Find a work<select aria-label="Choose an artwork"></select></label></div>';
    const puzzleLink=document.createElement('a');puzzleLink.className='puzzle-gallery-link';puzzleLink.href='https://vibesandvirtues.com/pages/landing#puzzle-artworks';puzzleLink.textContent=root.dataset.puzzleLink;$('.art-carousel').before(puzzleLink);
    const area=$('.art-carousel'),select=area.querySelector('select');
    function populate(){select.replaceChildren(...items.map((item,i)=>{const option=document.createElement('option');option.value=i;option.textContent=item.title;return option;}));}
    function draw(){const item=items[index];const im=makeImage(item),stage=area.querySelector('.art-stage');const loading=document.createElement('span');loading.className='art-loading';loading.textContent='Loading artwork';im.addEventListener('load',()=>loading.remove(),{once:true});im.addEventListener('error',()=>{loading.textContent='Opening image…';},{once:true});stage.replaceChildren(im,loading);if(im.complete&&im.naturalWidth)loading.remove();area.querySelector('.art-position').textContent=(index+1)+' / '+items.length;area.querySelector('h3').textContent=item.title;area.querySelector('.art-description p').textContent=[item.description,item.year].filter(Boolean).join(' · ');area.querySelector('a').href=item.url;select.value=index;area.dataset.index=index;area.dataset.total=items.length;}
    function move(delta){index=(index+delta+items.length)%items.length;draw();}
    area.querySelector('[data-art-prev]').addEventListener('click',()=>move(-1));area.querySelector('[data-art-next]').addEventListener('click',()=>move(1));select.addEventListener('change',()=>{index=Number(select.value);draw();});
    area.addEventListener('keydown',event=>{if(event.target.tagName==='SELECT')return;if(event.key==='ArrowRight'){event.preventDefault();move(1);}if(event.key==='ArrowLeft'){event.preventDefault();move(-1);}});
    let touchX;area.querySelector('.art-stage').addEventListener('touchstart',e=>{touchX=e.changedTouches[0].clientX;},{passive:true});area.querySelector('.art-stage').addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-touchX;if(Math.abs(dx)>45)move(dx<0?1:-1);},{passive:true});
    populate();draw();caseDialog.classList.add('art-dialog');openDialog(caseDialog,trigger);
    const fresh=await fetchFeed('visual');if(session!==artworkSession||!caseDialog.open)return;const current=items[index].title;items=arrange(fresh);index=Math.max(0,items.findIndex(x=>x.title===current));populate();draw();
  }
  caseDialog.addEventListener('close',()=>{artworkSession++;caseDialog.classList.remove('art-dialog');});
})();


(() => {
 const root=document.getElementById('carey-epk');
 if (!root) return;
 const toggle=root.querySelector('.menu-toggle');
 const links=root.querySelector('#portfolio-links');
 function closeMenu(){toggle.setAttribute('aria-expanded','false');links.classList.remove('is-open');}
 toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));links.classList.toggle('is-open',open);});
 links.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeMenu));
 root.querySelector('.artist-nav').addEventListener('keydown',e=>{if(e.key==='Escape'&&toggle.getAttribute('aria-expanded')==='true'){closeMenu();toggle.focus();}});
})();

(() => {
  const root = document.getElementById('carey-epk');
  if (!root) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const loops = [...root.querySelectorAll('video[data-project-loop]')];
  loops.forEach(video => {
    const playButton = video.parentElement.querySelector('.loop-control');
    const soundButton = video.parentElement.querySelector('.sound-control');
    let userPaused = reduced.matches;
    let visible = false;
    let starting = false;
    let autoplayBlocked = false;
    video.muted = true; video.defaultMuted = true; video.playsInline = true;
    function update() {
      playButton.textContent = video.error ? 'Retry video' : video.paused ? 'Play' : 'Pause';
      playButton.setAttribute('aria-label', (video.paused ? 'Play ' : 'Pause ') + video.dataset.projectLoop + ' video');
      playButton.setAttribute('aria-pressed', String(!video.paused));
      soundButton.textContent = video.muted ? 'Unmute' : 'Mute';
      soundButton.setAttribute('aria-label', (video.muted ? 'Unmute ' : 'Mute ') + video.dataset.projectLoop + ' video');
      soundButton.setAttribute('aria-pressed', String(!video.muted));
    }
    async function play() {
      if (starting || !video.paused) return;
      starting = true;
      try { await video.play(); autoplayBlocked = false; if (!visible || document.hidden || userPaused) video.pause(); } catch { autoplayBlocked = true; }
      finally { starting = false; update(); }
    }
    function sync() {
      if (visible && !document.hidden && !userPaused) play();
      else { video.pause(); if (!visible || document.hidden) video.muted = true; }
      update();
    }
    playButton.addEventListener('click', () => {
      if(video.error) { video.load(); userPaused=false; play(); return; }
      userPaused = !video.paused;
      if (userPaused) video.pause(); else play();
      update();
    });
    soundButton.addEventListener('click', () => {
      const unmuting = video.muted;
      if (unmuting) loops.forEach(other => { if (other !== video) other.muted = true; });
      video.muted = !unmuting; video.volume = 1;
      if (unmuting && video.paused) { userPaused = false; play(); }
      update();
    });
    ['play','pause','volumechange','error'].forEach(type => video.addEventListener(type,update));
    ['loadeddata','canplay','canplaythrough'].forEach(type => video.addEventListener(type,sync));
    document.addEventListener('pointerdown',()=>{if(autoplayBlocked && visible && !userPaused) sync();},{passive:true});
    document.addEventListener('keydown',()=>{if(autoplayBlocked && visible && !userPaused) sync();});
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; sync(); }, {threshold:0.01}).observe(video.parentElement);
    document.addEventListener('visibilitychange',sync);
    window.addEventListener('pageshow',sync);
    reduced.addEventListener('change',event => { if(event.matches) { userPaused=true;sync(); } });
    requestAnimationFrame(() => { const rect=video.getBoundingClientRect();visible=rect.bottom>0&&rect.top<innerHeight&&rect.width>0;sync(); });
    update();
  });
  function resetPlayer(shell) {
    shell.querySelector('.inline-player').replaceChildren();
    shell.querySelector('.inline-player').hidden = true;
    shell.querySelector('.film-poster').hidden = false;
  }
  function stopMedia(scope) {
    scope.querySelectorAll('video').forEach(v => v.pause());
    scope.querySelectorAll('[data-film-shell]').forEach(resetPlayer);
  }
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-embed]');
    if (!button) return;
    const url = new URL(button.dataset.embed);
    if (!['https://www.youtube.com', 'https://player.vimeo.com'].includes(url.origin)) return;
    const shell = button.closest('[data-film-shell]');
    root.querySelectorAll('[data-film-shell]').forEach(other => { if (other !== shell) resetPlayer(other); });
    const player = shell.querySelector('.inline-player');
    const iframe = document.createElement('iframe');
    iframe.src = url.href; iframe.title = button.dataset.title;
    iframe.allow = 'autoplay; fullscreen; picture-in-picture; encrypted-media';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.allowFullscreen = true;
    player.replaceChildren(iframe); player.hidden = false; button.hidden = true;
    iframe.focus();
  });
  root.querySelector('#case-dialog').addEventListener('close', event => stopMedia(event.target));
  const journey = root.querySelector('#journey-2');
  new MutationObserver(() => { if (journey.hidden) stopMedia(journey); }).observe(journey, { attributes: true, attributeFilter: ['hidden'] });
})();

(() => {
  const section = document.querySelector('#carey-epk #cf-experience.background-story');
  if (!section) return;
  const tabs = [...section.querySelectorAll('[role="tab"]')];
  const panels = [...section.querySelectorAll('[role="tabpanel"]')];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const carousels = new Map();
  const writingDialog = section.querySelector('#cf-npn-writing');
  let writingTrigger;
  let previousOverflow = '';
  section.querySelectorAll('[data-npn-writing]').forEach(button => {
    button.addEventListener('click', () => {
      writingTrigger = button;
      previousOverflow = document.documentElement.style.overflow;
      writingDialog.showModal();
      writingDialog.scrollTop = 0;
      document.documentElement.style.overflow = 'hidden';
    });
  });
  writingDialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    writingTrigger?.focus({preventScroll: true});
  });

  panels.forEach(panel => {
    const track = panel.querySelector('.background-track');
    const cards = [...track.querySelectorAll('.background-card')];
    const previous = panel.querySelector('[data-background-step="-1"]');
    const next = panel.querySelector('[data-background-step="1"]');
    const count = panel.querySelector('.background-count');
    const progress = panel.querySelector('.background-progress span');
    let timer;
    let desiredIndex = null;
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const position = card => card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft - 4;
    const index = () => {
      if (track.scrollLeft >= maxScroll() - 2) return cards.length - 1;
      return cards.reduce((best, card, i) => Math.abs(position(card) - track.scrollLeft) < Math.abs(position(cards[best]) - track.scrollLeft) ? i : best, 0);
    };
    function update() {
      if (panel.hidden || !track.clientWidth) return;
      const current = index();
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll() - 2;
      count.textContent = `${String(current + 1).padStart(2, '0')} / ${String(cards.length).padStart(2, '0')}`;
      progress.style.width = `${maxScroll() ? Math.max(1 / cards.length, track.scrollLeft / maxScroll()) * 100 : 100}%`;
    }
    function moveTo(i) {
      desiredIndex = Math.max(0, Math.min(cards.length - 1, i));
      track.scrollTo({left: Math.min(maxScroll(), Math.max(0, position(cards[desiredIndex]))), behavior: reducedMotion.matches ? 'instant' : 'smooth'});
      clearTimeout(timer);
      timer = setTimeout(() => { desiredIndex = null; update(); }, 450);
    }
    function step(direction) {
      const left = track.scrollLeft;
      if (direction < 0) {
        const before = cards.map((card, i) => ({i, x: position(card)})).filter(card => card.x < left - 2);
        moveTo(desiredIndex !== null ? desiredIndex - 1 : before.length ? before.at(-1).i : 0);
      } else {
        moveTo((desiredIndex !== null ? desiredIndex : index()) + 1);
      }
    }
    previous.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', () => {
      clearTimeout(timer);
      timer = setTimeout(() => { desiredIndex = null; update(); }, 140);
    }, {passive: true});
    track.addEventListener('keydown', event => {
      if (event.target !== track) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1);
      } else if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault(); moveTo(event.key === 'Home' ? 0 : cards.length - 1);
      }
    });
    const observer = new ResizeObserver(update);
    observer.observe(track);
    carousels.set(panel.id, update);
    update();
  });

  function activate(tab, focus = false) {
    tabs.forEach(item => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
    });
    panels.forEach(panel => { panel.hidden = panel.id !== tab.getAttribute('aria-controls'); });
    carousels.get(tab.getAttribute('aria-controls'))?.();
    if (focus) tab.focus({preventScroll: true});
  }
  tabs.forEach((tab, i) => {
    tab.addEventListener('click', () => activate(tab));
    tab.addEventListener('keydown', event => {
      let target;
      if (event.key === 'ArrowRight') target = (i + 1) % tabs.length;
      if (event.key === 'ArrowLeft') target = (i + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = tabs.length - 1;
      if (target !== undefined) { event.preventDefault(); activate(tabs[target], true); }
    });
  });
})();


(()=>{
 const root=document.getElementById('cf-instagram-feed');if(!root)return;
 const t=JSON.parse(root.querySelector('[data-ig-copy]').textContent),track=root.querySelector('[data-ig-track]'),dialog=root.querySelector('dialog'),login=root.querySelector('[data-ig-login]'),owner=root.querySelector('[data-ig-owner]'),status=root.querySelector('[data-ig-status]'),feedback=root.querySelector('[data-ig-feedback]');
 const form=document.getElementById('inquiry-form'),key=form?.dataset.publicKey;
 if(!key)return;
 const endpoint='https://vwjkibwaqqyhllhrlttv.supabase.co/functions/v1/carey-instagram-feed';
 let session='',pending=null,busy=false,returnFocus=null;
 const node=(tag,text,cls)=>{const e=document.createElement(tag);if(text)e.textContent=text;if(cls)e.className=cls;return e;};
 function publicLink(url){try{const u=new URL(url);return u.protocol==='https:'&&(u.hostname==='www.instagram.com'||u.hostname==='instagram.com');}catch{return false;}}
 function imageLink(url){try{const u=new URL(url);return u.protocol==='https:'&&(u.hostname.endsWith('.cdninstagram.com')||u.hostname.endsWith('.fbcdn.net')||u.hostname==='cdn.shopify.com');}catch{return false;}}
 async function api(body){const headers={apikey:key,Authorization:'Bearer '+key};if(body){headers['Content-Type']='application/json';if(session)headers['x-owner-session']=session;}
  const r=await fetch(endpoint,{method:body?'POST':'GET',headers,body:body?JSON.stringify(body):undefined,signal:AbortSignal.timeout(20000)});const data=await r.json();if(!r.ok){if(r.status===401&&body?.action!=='login'){session='';owner.hidden=true;login.hidden=false;throw new Error(t.expired);}throw new Error(data.error||t.error);}return data;
 }
 function render(posts){track.replaceChildren();for(const p of posts){if(!publicLink(p.permalink)||!imageLink(p.image_url))continue;const card=node('article','', 'ig-card');const link=node('a');link.href=p.permalink;link.target='_blank';link.rel='noopener';const img=node('img');img.src=p.image_url;img.alt=(p.caption||t.post).slice(0,180);img.loading='lazy';img.decoding='async';img.width=600;img.height=600;img.addEventListener('error',()=>{img.hidden=true;},{once:true});link.append(img);if(!p.id.startsWith('seed_'))link.append(node('span',new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'short',day:'numeric',year:'numeric'}).format(new Date(p.posted_at)),'tiny'));link.append(node('p',p.caption||t.post,'ig-caption'),node('span',t.view,'text-link'));const remove=node('button','×','ig-remove');remove.type='button';remove.setAttribute('aria-label',t.hide);remove.title=t.hide;remove.addEventListener('click',()=>open(p.id,remove));card.append(link,remove);track.append(card);}root.querySelector('.ig-paging').hidden=posts.length<4;}
 async function refresh(){const data=await api();render(data.posts);return data;}
 async function ownerStatus(){const data=await api({action:'status'});root.querySelector('[data-ig-connection]').textContent=!data.connected?t.not_connected:data.last_sync_ok?t.connected:t.sync_error;const list=root.querySelector('[data-ig-hidden]');list.replaceChildren();if(!data.hidden.length)list.append(node('p',t.empty));for(const p of data.hidden){const row=node('div','','ig-hidden-row'),button=node('button',t.restore);button.type='button';button.addEventListener('click',()=>work(async()=>{await api({action:'restore',id:p.id});await refresh();await ownerStatus();status.textContent=t.restore_feedback;feedback.textContent=t.restore_feedback;}));row.append(node('span',(p.caption||t.post).slice(0,100)),button);list.append(row);}owner.hidden=false;login.hidden=true;root.querySelector('[data-ig-pending]').hidden=!pending;}
 async function work(fn){if(busy)return;busy=true;dialog.querySelectorAll('button[type="submit"],[data-ig-confirm]').forEach(b=>b.disabled=true);status.textContent=t.busy;try{await fn();}catch(e){status.textContent=e.message||t.error;}finally{busy=false;dialog.querySelectorAll('button[type="submit"],[data-ig-confirm]').forEach(b=>b.disabled=false);}}
 function open(id,trigger){returnFocus=trigger;pending=id;status.textContent='';login.reset();root.querySelector('[data-ig-connect]').reset();login.hidden=!!session;owner.hidden=!session;dialog.showModal();if(session)work(async()=>{await ownerStatus();status.textContent='';});else login.elements.password.focus();}
 function close(){if(busy)return;dialog.close();login.reset();root.querySelector('[data-ig-connect]').reset();pending=null;returnFocus?.focus();}
 root.querySelector('[data-ig-manage]').addEventListener('click',e=>open(null,e.currentTarget));root.querySelector('[data-ig-close]').addEventListener('click',close);dialog.addEventListener('cancel',e=>{e.preventDefault();close();});
 login.addEventListener('submit',e=>{e.preventDefault();work(async()=>{const password=login.elements.password.value;login.reset();const result=await api({action:'login',password});session=result.session;await ownerStatus();status.textContent='';});});
 root.querySelector('[data-ig-confirm]').addEventListener('click',()=>work(async()=>{if(!pending)return;await api({action:'hide',id:pending});pending=null;await refresh();await ownerStatus();status.textContent=t.hidden_feedback;feedback.textContent=t.hidden_feedback;}));
 root.querySelector('[data-ig-connect]').addEventListener('submit',e=>{e.preventDefault();work(async()=>{const token=e.target.elements.token.value.trim();e.target.reset();await api({action:'connect',token});await refresh();await ownerStatus();status.textContent=t.connect_success;});});
 root.querySelector('[data-ig-lock]').addEventListener('click',()=>{session='';owner.hidden=true;login.hidden=false;status.textContent='';login.elements.password.focus();});
 root.querySelector('[data-ig-prev]').addEventListener('click',()=>track.scrollBy({left:-track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));root.querySelector('[data-ig-next]').addEventListener('click',()=>track.scrollBy({left:track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
 const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();refresh().catch(()=>{});}},{rootMargin:'600px'});observer.observe(root);
})();


(()=>{
 const root=document.getElementById('cf-conversation');if(!root)return;
 const q=s=>root.querySelector(s),form=q('[data-cb-form]'),steps=[...root.querySelectorAll('[data-cb-step]')],t=JSON.parse(q('[data-cb-copy]').textContent),source=document.getElementById('inquiry-form');
 let current=0,busy=false,attempt=null;
 const values=()=>Object.fromEntries(new FormData(form));
 const supportText=v=>t[v]||t.explore;
 const rows=v=>[[t.brief_goal,v.goal+'\n'+v.goalDetail],[t.brief_audience,[v.audience,v.participants,v.setting,v.location].filter(Boolean).join(' · ')],[t.brief_conversation,v.conversation],[t.brief_support,supportText(v.support)+'\n'+t[v.support+'_desc']],...(v.support==='board'?[]:[[t.brief_capture,v.capture||t.unspecified]])];
 function review(){const dl=document.createElement('dl');for(const [label,value] of rows(values())){const dt=document.createElement('dt'),dd=document.createElement('dd');dt.textContent=label;dd.textContent=value;dl.append(dt,dd);}q('[data-cb-review]').replaceChildren(dl);}
 function show(n,focus=true){current=n;steps.forEach((s,i)=>{s.hidden=i!==n;s.disabled=i!==n;});q('[data-cb-progress]').textContent=t.progress.replace('__N__',String(n+1));q('[data-cb-back]').hidden=n===0;q('[data-cb-next]').hidden=n===4;q('[data-cb-send]').hidden=n!==4;if(n===4){steps.forEach(s=>s.disabled=false);review();steps.forEach((s,i)=>s.disabled=i!==n);}if(focus)steps[n].querySelector('legend').focus();q('[data-cb-status]').textContent='';}
 function validate(){for(const el of steps[current].querySelectorAll('input,select,textarea')){if(!el.reportValidity())return false;}return true;}
 function allValues(){steps.forEach(s=>s.disabled=false);const v=values();steps.forEach((s,i)=>s.disabled=i!==current);return v;}
 q('[data-cb-start]').hidden=false;
 q('[data-cb-start]').addEventListener('click',()=>{q('[data-cb-workspace]').hidden=false;q('[data-cb-start]').hidden=true;show(current);});
 q('[data-cb-collapse]').addEventListener('click',()=>{if(busy)return;q('[data-cb-workspace]').hidden=true;q('[data-cb-start]').hidden=false;q('[data-cb-start]').focus();});
 q('[data-cb-back]').addEventListener('click',()=>{if(!busy)show(Math.max(0,current-1));});
 q('[data-cb-next]').addEventListener('click',()=>{if(!busy&&validate())show(Math.min(4,current+1));});
 form.addEventListener('change',()=>{const s=form.elements.support.value;q('[data-cb-capture]').hidden=!s||s==='board';if(s==='board')form.elements.capture.value='';});
 q('[data-cb-reset]').addEventListener('click',()=>{form.reset();attempt=null;q('[data-cb-success]').hidden=true;form.hidden=false;q('[data-cb-capture]').hidden=true;show(0);});
 form.addEventListener('submit',async e=>{
  e.preventDefault();if(busy)return;if(current!==4){if(validate())show(current+1);return;}if(!validate())return;
  const v=allValues(),message=[t.brief_title,'',...rows(v).map(([a,b])=>a+':\n'+b+'\n'),t.brief_org+': '+(v.organization||t.unspecified),'',t.brief_note].join('\n');
  const payload={name:v.name,email:v.email,interest:'Experiences & programming',location:v.location||'',timing:v.timing||'',budget:v.budget||'',website:v.website||'',message};
  const fingerprint=JSON.stringify(payload);if(!attempt||attempt.fingerprint!==fingerprint)attempt={fingerprint,requestId:crypto.randomUUID()};
  busy=true;form.setAttribute('aria-busy','true');const controls=[...root.querySelectorAll('button')];controls.forEach(b=>b.disabled=true);q('[data-cb-status]').textContent=t.sending;
  try{const r=await fetch(source.dataset.endpoint,{method:'POST',headers:{'Content-Type':'application/json',apikey:source.dataset.publicKey,Authorization:'Bearer '+source.dataset.publicKey},body:JSON.stringify({...payload,requestId:attempt.requestId}),signal:AbortSignal.timeout(30000)});const data=await r.json();if(!r.ok||!data.ok){if(r.status===409)attempt=null;throw new Error(r.status===429?t.rate:t.error);}form.hidden=true;q('[data-cb-success]').hidden=false;q('[data-cb-success]').focus();}
  catch(err){q('[data-cb-status]').textContent=err.message===t.rate?t.rate:t.error;q('[data-cb-status]').focus();}
  finally{busy=false;form.removeAttribute('aria-busy');controls.forEach(b=>b.disabled=false);}
 });
 show(0,false);
})();


(() => {
 const image=document.getElementById('carey-hero-montage');
 if(!image)return;
 const button=image.parentElement.querySelector('.montage-control');
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const frames=JSON.parse(document.getElementById('carey-montage-frames').textContent);
 const caption=image.parentElement.querySelector('.montage-opening-caption');
 let running=false,index=0,timer;
 function advance(){if(!running)return;const next=(index+1)%frames.length;const preload=new Image();preload.onload=()=>{if(!running)return;index=next;image.src=frames[index];image.dataset.scene=String(index);caption.hidden=index!==0;timer=setTimeout(advance,3000);};preload.onerror=()=>{if(running)timer=setTimeout(advance,3000);};preload.src=frames[next];}
 function setMotion(enabled){running=enabled;clearTimeout(timer);button.textContent=enabled?button.dataset.pause:button.dataset.play;button.setAttribute('aria-pressed',String(enabled));if(enabled)timer=setTimeout(advance,3000);}
 button.addEventListener('click',()=>setMotion(!running));
 reduced.addEventListener('change',e=>{if(e.matches)setMotion(false);});
 if(!reduced.matches)setMotion(true);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-connections"] && !Shopify.designMode) return;
  try {
    
(()=>{function init(scope=document){scope.querySelectorAll('[data-vv-page]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const dialog=root.querySelector('.video-dialog'),mount=root.querySelector('.video-mount'),opener=root.querySelector('[data-video-open]');
opener.addEventListener('click',()=>{const frame=document.createElement('iframe');frame.src=mount.dataset.embed;frame.title=opener.getAttribute('aria-label');frame.allow='accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';mount.replaceChildren(frame);dialog.showModal();document.body.classList.add('vv-video-open');});root.querySelector('.video-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});dialog.addEventListener('close',()=>{mount.replaceChildren();document.body.classList.remove('vv-video-open');});
const grid=root.querySelector('[data-collections-source]');const load=async()=>{try{const response=await fetch(grid.dataset.collectionsSource,{credentials:'same-origin'});if(!response.ok)return;const doc=new DOMParser().parseFromString(await response.text(),'text/html');const template=doc.querySelector('template[data-vv-homepage-collections]');if(template&&template.content.querySelectorAll('.collection-card').length){grid.replaceChildren(template.content.cloneNode(true));}}catch{}};if('IntersectionObserver'in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){observer.disconnect();load();}},{rootMargin:'600px'});observer.observe(grid);}else load();});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();document.addEventListener('shopify:section:load',e=>init(e.target));document.addEventListener('shopify:section:unload',()=>document.body.classList.remove('vv-video-open'));})();
(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('.merch-section').forEach(section => {
      if (section.dataset.rotationReady) return;
      section.dataset.rotationReady = 'true';
      const grid = section.querySelector('.collection-grid');
      const toggle = section.querySelector('[data-rotation-toggle]');
      if (!grid || !toggle) return;
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = motion.matches;
      let states = [];
      const signalController = new AbortController();
      const signal = signalController.signal;
      function updateToggle() {
        toggle.hidden = !states.some(state => state.frames.length > 1);
        toggle.textContent = paused ? toggle.dataset.play : toggle.dataset.pause;
        toggle.setAttribute('aria-pressed', String(paused));
      }
      function canRun(state) {
        return state.alive && state.visible && !state.hovered && !state.focused && !paused && !document.hidden && state.frames.length > 1;
      }
      function schedule(state) {
        clearTimeout(state.timer);
        if (canRun(state) && !state.busy) state.timer = setTimeout(() => advance(state), 1600);
      }
      async function advance(state) {
        if (!canRun(state)) return;
        state.busy = true;
        const nextIndex = (state.index + 1) % state.frames.length;
        const frame = state.frames[nextIndex];
        const nextImage = state.images[1 - state.front];
        nextImage.src = frame.src;
        nextImage.alt = frame.alt;
        try {
          await nextImage.decode();
          if (canRun(state)) {
            state.images[state.front].classList.remove('is-current');
            state.images[state.front].setAttribute('aria-hidden', 'true');
            nextImage.classList.add('is-current');
            nextImage.removeAttribute('aria-hidden');
            state.front = 1 - state.front;
            state.index = nextIndex;
            state.card.dataset.productIndex = String(nextIndex);
          }
        } catch {
          state.frames.splice(nextIndex, 1);
          if (nextIndex < state.index) state.index--;
          updateToggle();
        }
        state.busy = false;
        schedule(state);
      }
      async function loadFrames(state) {
        if (state.loaded || !state.alive) return;
        state.loaded = true;
        let url = new URL(state.card.dataset.rotationSource, location.href);
        const visited = new Set();
        const products = new Set();
        try {
          while (url && !visited.has(url.href) && state.alive) {
            if (url.origin !== location.origin) break;
            visited.add(url.href);
            const response = await fetch(url, {credentials: 'same-origin', signal});
            if (!response.ok) break;
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const template = doc.querySelector('template[data-collection-frames]');
            if (!template) break;
            template.content.querySelectorAll('[data-product-id][data-src]').forEach(item => {
              if (products.has(item.dataset.productId)) return;
              products.add(item.dataset.productId);
              state.frames.push({id: item.dataset.productId, src: item.dataset.src, alt: item.dataset.alt});
            });
            state.card.dataset.frameCount = String(state.frames.length);
            const next = template.dataset.nextUrl;
            url = next ? new URL(next, url) : null;
            if (url && !state.card.dataset.rotationSource.endsWith('.html')) url.searchParams.set('view', 'homepage-frames');
          }
          if (!state.alive) return;
          const first = state.frames.findIndex(frame => frame.id === state.card.dataset.firstProduct);
          state.index = first < 0 ? 0 : first;
          if (state.frames.length) {
            state.images[0].removeAttribute('srcset');
            state.images[0].removeAttribute('sizes');
            state.images[0].src = state.frames[state.index].src;
            state.images[0].alt = state.frames[state.index].alt;
          }
          updateToggle();
          schedule(state);
        } catch {
        }
      }
      const visibility = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = states.find(item => item.card === entry.target);
          if (!state) return;
          state.visible = entry.isIntersecting;
          if (state.visible) loadFrames(state);
          schedule(state);
        });
      }, {threshold: 0.15});
      function refresh() {
        states.forEach(state => {state.alive = false; clearTimeout(state.timer); state.listeners.abort();});
        visibility.disconnect();
        states = [...grid.querySelectorAll('[data-rotation-source]')].map(card => {
          const art = card.querySelector('.collection-art');
          const first = art?.querySelector('img');
          if (!first) return null;
          art.querySelectorAll('.collection-frame-next').forEach(image => image.remove());
          first.classList.add('collection-frame', 'is-current');
          const next = document.createElement('img');
          next.className = 'collection-frame collection-frame-next';
          next.alt = '';
          next.setAttribute('aria-hidden', 'true');
          next.decoding = 'async';
          art.append(next);
          const state = {card, images: [first, next], frames: [], index: 0, front: 0, alive: true, visible: false, hovered: false, focused: false, busy: false, listeners: new AbortController()};
          const options = {signal: state.listeners.signal};
          card.addEventListener('mouseenter', () => {state.hovered = true; schedule(state);}, options);
          card.addEventListener('mouseleave', () => {state.hovered = false; schedule(state);}, options);
          card.addEventListener('focusin', () => {state.focused = true; schedule(state);}, options);
          card.addEventListener('focusout', event => {if (!card.contains(event.relatedTarget)) {state.focused = false; schedule(state);}}, options);
          visibility.observe(card);
          return state;
        }).filter(Boolean);
        updateToggle();
      }
      const changes = new MutationObserver(refresh);
      changes.observe(grid, {childList: true});
      toggle.addEventListener('click', () => {paused = !paused; updateToggle(); states.forEach(schedule);}, {signal});
      document.addEventListener('visibilitychange', () => states.forEach(schedule), {signal});
      motion.addEventListener('change', () => {paused = motion.matches; updateToggle(); states.forEach(schedule);}, {signal});
      section.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => {
        signalController.abort();
        changes.disconnect();
        visibility.disconnect();
        states.forEach(state => {state.alive = false; clearTimeout(state.timer); state.listeners.abort();});
      }, {once: true});
      refresh();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-experience-slider"] && !Shopify.designMode) return;
  try {
    
  (()=>{
    function initialize(root){
      if(!root||root.dataset.ready)return;
      root.dataset.ready='true';
      const slides=[...root.querySelectorAll('[data-slide]')];
      const buttons=[...root.querySelectorAll('[data-slide-button]')];
      const pauseButton=root.querySelector('[data-pause-button]');
      if(slides.length<2||!pauseButton)return;
      const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
      let current=0,timer,userPaused=true,hovered=false,touchStart=null;
      function schedule(){clearTimeout(timer);if(!userPaused&&!hovered&&!root.contains(document.activeElement)&&!document.hidden)timer=setTimeout(()=>select(current+1),7000)}
      function select(index){current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>slide.hidden=i!==current);buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===current)));schedule()}
      function updatePause(){pauseButton.textContent=userPaused?root.dataset.resume:root.dataset.pause;pauseButton.setAttribute('aria-pressed',String(userPaused));schedule()}
      buttons.forEach((button,i)=>{button.addEventListener('click',()=>select(i));button.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();select(current+(event.key==='ArrowRight'?1:-1));buttons[current].focus()}})});
      pauseButton.addEventListener('click',()=>{userPaused=!userPaused;updatePause()});
      root.addEventListener('mouseenter',()=>{hovered=true;schedule()});root.addEventListener('mouseleave',()=>{hovered=false;schedule()});
      root.addEventListener('focusin',schedule);root.addEventListener('focusout',()=>setTimeout(schedule,0));
      function visibilityChanged(){schedule()}
      function motionChanged(){if(motion.matches){userPaused=true;updatePause()}}
      function selectBlock(event){const index=slides.findIndex(slide=>slide.dataset.blockId===event.detail.blockId);if(index>=0){userPaused=true;select(index);updatePause()}}
      document.addEventListener('visibilitychange',visibilityChanged);document.addEventListener('shopify:block:select',selectBlock);motion.addEventListener('change',motionChanged);
      root.addEventListener('touchstart',event=>{touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY}},{passive:true});
      root.addEventListener('touchend',event=>{if(!touchStart)return;const dx=event.changedTouches[0].clientX-touchStart.x,dy=event.changedTouches[0].clientY-touchStart.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)select(current+(dx<0?1:-1));touchStart=null},{passive:true});
      root.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>{clearTimeout(timer);document.removeEventListener('visibilitychange',visibilityChanged);document.removeEventListener('shopify:block:select',selectBlock);motion.removeEventListener('change',motionChanged)},{once:true});
      updatePause();
    }
    document.querySelectorAll('[data-vv-home]').forEach(initialize);
    document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-vv-home]').forEach(initialize));
  })();

  } catch(e) { console.error(e); }
})();
})();
